var _defs, _path, _path2, _circle, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNamaz3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Namaz-3_svg__Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 162.5 74.57"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Namaz-3_svg__cls-1,.Namaz-3_svg__cls-2{fill:#fdb515;stroke:#c4820e;stroke-miterlimit:10}.Namaz-3_svg__cls-2{fill:none;stroke-width:.5px}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-3_svg__cls-1",
    transform: "rotate(-100.04 53.054 116.141)",
    d: "M127.87 136.75h13.75v13.75h-13.75z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-3_svg__cls-1",
    d: "M222.12 163.06h-9.24v-30a8.75 8.75 0 00-1.06-4.17 20.23 20.23 0 00-23.24-15.4l-33 5.84a20.25 20.25 0 007.06 39.88l32.73-5.79v15.45a8.74 8.74 0 008.24 11.65h18.5a8.75 8.75 0 100-17.5z",
    transform: "translate(-68.87 -112.72)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "Namaz-3_svg__cls-1",
    cx: 33.01,
    cy: 36.73,
    r: 30
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-3_svg__cls-1",
    d: "M175.6 164.37a8 8 0 00-1-3.58l-15.1-27.09a8 8 0 00-10.89-3.1 8 8 0 00-3.1 10.9l11.79 21.13-12.82 9.78a8 8 0 009.71 12.73l18.28-13.94a8 8 0 003.14-6.39c0-.14 0-.29-.01-.44z",
    transform: "translate(-68.87 -112.72)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-3_svg__cls-2",
    d: "M98.61 179.73s-8.21.7-10.39.46c-15.12-1.71-19.15-17.87-6.78-25.63 2.06-1.29 12-4.18 12-4.18z",
    transform: "translate(-68.87 -112.72)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-3_svg__cls-2",
    d: "M98.48 179s-8.21.7-10.39.45c-15.12-1.7-19.15-17.87-6.78-25.62 2.06-1.29 12-4.19 12-4.19z",
    transform: "translate(-68.87 -112.72)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-3_svg__cls-2",
    d: "M98.33 178.14s-8.21.7-10.39.46c-15.12-1.71-19.15-17.87-6.79-25.63 2.07-1.29 12-4.18 12-4.18z",
    transform: "translate(-68.87 -112.72)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-3_svg__cls-2",
    d: "M98.18 177.28s-8.21.71-10.4.46C72.67 176 68.64 159.87 81 152.12c2.07-1.3 12-4.19 12-4.19z",
    transform: "translate(-68.87 -112.72)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-3_svg__cls-2",
    d: "M98 176.43s-8.21.7-10.4.46c-15.11-1.71-19.15-17.88-6.78-25.63 2.06-1.29 12-4.19 12-4.19z",
    transform: "translate(-68.87 -112.72)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-3_svg__cls-2",
    d: "M97.83 175.33s-8.21.7-10.39.45c-15.12-1.7-19.15-17.87-6.78-25.62 2.06-1.29 12-4.19 12-4.19z",
    transform: "translate(-68.87 -112.72)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-3_svg__cls-2",
    d: "M97.64 174.23s-8.21.7-10.4.45c-15.11-1.7-19.15-17.87-6.78-25.62 2.06-1.29 12-4.19 12-4.19z",
    transform: "translate(-68.87 -112.72)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-3_svg__cls-2",
    d: "M97.44 173.12s-8.21.71-10.39.46c-15.12-1.7-19.15-17.87-6.78-25.62 2.06-1.29 12-4.19 12-4.19z",
    transform: "translate(-68.87 -112.72)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-3_svg__cls-2",
    d: "M97.31 172.39s-8.21.71-10.39.46c-15.12-1.71-19.15-17.85-6.78-25.62 2.06-1.3 12-4.19 12-4.19z",
    transform: "translate(-68.87 -112.72)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-3_svg__cls-2",
    d: "M97.12 171.29s-8.21.71-10.4.46c-15.11-1.71-19.14-17.87-6.78-25.62 2.06-1.3 12-4.19 12-4.19z",
    transform: "translate(-68.87 -112.72)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-3_svg__cls-2",
    d: "M96.94 170.31s-8.2.71-10.39.46c-15.11-1.71-19.15-17.87-6.78-25.62 2.06-1.3 12-4.19 12-4.19z",
    transform: "translate(-68.87 -112.72)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-3_svg__cls-2",
    d: "M96.79 169.46s-8.21.7-10.39.45c-15.12-1.7-19.15-17.87-6.78-25.62 2.06-1.29 12-4.19 12-4.19z",
    transform: "translate(-68.87 -112.72)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-3_svg__cls-2",
    d: "M96.66 168.72s-8.21.71-10.39.46c-15.12-1.71-19.15-17.87-6.78-25.62 2.06-1.3 12-4.19 12-4.19z",
    transform: "translate(-68.87 -112.72)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-3_svg__cls-2",
    d: "M96.53 168s-8.21.7-10.39.46C71 166.74 67 150.58 79.36 142.82c2.06-1.29 12-4.18 12-4.18z",
    transform: "translate(-68.87 -112.72)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-3_svg__cls-2",
    d: "M96.34 166.89s-8.21.7-10.4.46c-15.11-1.71-19.14-17.87-6.78-25.63 2.07-1.29 12-4.19 12-4.19z",
    transform: "translate(-68.87 -112.72)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-3_svg__cls-2",
    d: "M96.21 166.15s-8.21.71-10.4.46C70.7 164.91 66.67 148.74 79 141c2.07-1.3 12-4.19 12-4.19z",
    transform: "translate(-68.87 -112.72)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-3_svg__cls-2",
    d: "M96 165.05s-8.21.71-10.39.46c-15.11-1.7-19.15-17.87-6.78-25.62 2.06-1.3 12-4.19 12-4.19z",
    transform: "translate(-68.87 -112.72)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-3_svg__cls-2",
    d: "M95.88 164.32s-8.21.7-10.39.46c-15.11-1.71-19.15-17.87-6.78-25.63 2.06-1.29 12-4.18 12-4.18z",
    transform: "translate(-68.87 -112.72)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-3_svg__cls-2",
    d: "M95.73 163.46s-8.21.71-10.39.46c-15.12-1.7-19.15-17.87-6.78-25.62 2.06-1.3 12-4.19 12-4.19z",
    transform: "translate(-68.87 -112.72)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-3_svg__cls-2",
    d: "M95.58 162.61s-8.21.7-10.39.46c-15.12-1.71-19.19-17.88-6.79-25.63 2.07-1.29 12-4.19 12-4.19z",
    transform: "translate(-68.87 -112.72)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-3_svg__cls-2",
    d: "M95.43 161.75s-8.21.71-10.4.46c-15.11-1.71-19.14-17.87-6.78-25.62 2.07-1.3 12-4.19 12-4.19z",
    transform: "translate(-68.87 -112.72)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-3_svg__cls-2",
    d: "M95.23 160.65s-8.2.71-10.39.46c-15.11-1.71-19.15-17.87-6.78-25.63 2.06-1.29 12-4.18 12-4.18z",
    transform: "translate(-68.87 -112.72)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-3_svg__cls-2",
    d: "M95 159.55s-8.21.7-10.4.46c-15.11-1.71-19.14-17.87-6.78-25.63 2.07-1.29 12-4.18 12-4.18z",
    transform: "translate(-68.87 -112.72)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-3_svg__cls-2",
    d: "M94.91 158.82s-8.21.7-10.4.45c-15.11-1.7-19.14-17.87-6.78-25.62 2.07-1.29 12-4.19 12-4.19z",
    transform: "translate(-68.87 -112.72)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-3_svg__cls-2",
    d: "M94.71 157.71s-8.2.71-10.39.46c-15.11-1.7-19.15-17.87-6.78-25.62 2.06-1.29 12-4.19 12-4.19z",
    transform: "translate(-68.87 -112.72)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-3_svg__cls-2",
    d: "M94.52 156.61s-8.21.71-10.4.46C69 155.37 65 139.2 77.34 131.45c2.07-1.29 12-4.19 12-4.19z",
    transform: "translate(-68.87 -112.72)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-3_svg__cls-2",
    d: "M94.35 155.64s-8.21.7-10.4.45c-15.11-1.7-19.15-17.87-6.78-25.62 2.06-1.29 12-4.19 12-4.19z",
    transform: "translate(-68.87 -112.72)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-3_svg__cls-2",
    d: "M94.19 154.78s-8.2.7-10.39.46c-15.11-1.71-19.15-17.87-6.78-25.63 2.06-1.29 12-4.18 12-4.18z",
    transform: "translate(-68.87 -112.72)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-3_svg__cls-2",
    d: "M94.06 154.05s-8.2.7-10.39.45c-15.11-1.7-19.15-17.87-6.78-25.62 2.06-1.29 12-4.19 12-4.19z",
    transform: "translate(-68.87 -112.72)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-3_svg__cls-2",
    d: "M93.93 153.31s-8.2.71-10.39.46c-15.11-1.71-19.15-17.87-6.78-25.62 2.06-1.3 12-4.19 12-4.19z",
    transform: "translate(-68.87 -112.72)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-3_svg__cls-2",
    d: "M93.74 152.21s-8.21.71-10.39.46C68.23 151 64.2 134.8 76.56 127.05c2.07-1.3 12-4.19 12-4.19z",
    transform: "translate(-68.87 -112.72)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-3_svg__cls-2",
    d: "M93.61 151.48s-8.21.7-10.39.46c-15.12-1.71-19.15-17.87-6.79-25.63 2.07-1.29 12-4.19 12-4.19z",
    transform: "translate(-68.87 -112.72)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-3_svg__cls-2",
    d: "M93.61 151.48s-8.21.7-10.39.46c-15.12-1.71-19.15-17.87-6.79-25.63 2.07-1.29 12-4.19 12-4.19z",
    transform: "translate(-68.87 -112.72)"
  })));
}

export default SvgNamaz3;